import { useState, useEffect, useCallback } from "react";
// eslint-disable-next-line no-unused-vars
import { toast } from "react-toastify";
import { listSupportTickets, saveSupportTicket } from "../../../../services/platform_admin_service";

const usePlatformSupport = () => {
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25, totalItems: 0, totalPages: 0 });
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchTickets = useCallback(async (page = 1, pageSize = 25, currentFilters = {}) => {
        try {
            setLoading(true);
            setError(null);
            const result = await listSupportTickets({ page, pageSize, filters: currentFilters });
            setItems(result.items || []);
            setPagination(result.pagination || {});
        } catch (err) {
            console.error("[usePlatformSupport]", err);
            setError(err.message || "Erro ao carregar chamados.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTickets(1, 25, filters);
    }, [fetchTickets, filters]);

    const goToPage = (page) => fetchTickets(page, pagination.pageSize, filters);
    const applyFilters = (newFilters) => setFilters(newFilters);

    const saveTicket = async (ticketData) => {
        try {
            setLoading(true);
            setError(null);
            const result = await saveSupportTicket(ticketData);
            await fetchTickets(pagination.page || 1, pagination.pageSize || 25, filters);
            toast.success(ticketData.id ? "Chamado atualizado com sucesso!" : "Chamado criado com sucesso!");
            return result;
        } catch (err) {
            const msg = err.message || "Erro ao salvar chamado.";
            setError(msg);
            toast.error(msg);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        items,
        pagination,
        loading,
        error,
        goToPage,
        applyFilters,
        filters,
        saveTicket,
        refetch: () => fetchTickets(pagination.page || 1, pagination.pageSize || 25, filters),
    };
};

export default usePlatformSupport;
